import React from "react";
import { Link } from "react-router-dom";
import { Zap, Clock, MapPin } from "lucide-react";

/**
 * UrgencyBadge — promesse produit « ⚡ Urgence » activée par le SEO audit du 7 sept 2026.
 * Bloc visible côté client (Landing homepage) qui matérialise la promesse produit
 * derrière les pages SEO « urgence / dernière minute / remplacement ».
 *
 * Cible : capter l'intention d'achat maximale (patron qui a un vrai problème NOW).
 */
export default function UrgencyBadge() {
    return (
        <section
            className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20"
            data-testid="urgency-badge-section"
        >
            <div className="sd-card overflow-hidden bg-gradient-to-br from-red-50 via-white to-white border-2 border-red-200">
                <div className="grid md:grid-cols-12 gap-6 p-8 md:p-12 items-center">
                    <div className="md:col-span-8">
                        <div className="pill mb-4 inline-flex items-center gap-2 bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-black uppercase tracking-wider">
                            <Zap size={12} /> Urgence · promesse produit Lyon
                        </div>
                        <h2 className="font-display text-3xl md:text-4xl tracking-tight text-[#0B192C] mb-4">
                            Un no-show, un arrêt, un pic imprévu ?<br />
                            <span className="text-red-700">Candidature qualifiée en moins de 4 h ouvrées.</span>
                        </h2>
                        <p className="text-slate-600 leading-relaxed mb-6">
                            Cochez « Mission urgente » (moins de 24 h) dans le configurateur — les Super Talents Renforteo à moins de 20 min de votre adresse sont alertés en priorité par push + SMS + email. Supplément +10 % pour dédommager le déplacement de dernière minute et rendre la mission attractive. Statistique moyenne mesurée sur les 6 derniers mois à Lyon : première candidature en <b>1 h 45 min</b> en semaine.
                        </p>
                        <div className="flex flex-wrap gap-3">
                            <Link
                                to="/trouver-serveur-derniere-minute-lyon"
                                className="btn-navy text-sm"
                                data-testid="urgency-cta-serveur"
                            >
                                Trouver un serveur dernière minute
                            </Link>
                            <Link
                                to="/remplacement-salarie-absent-lyon"
                                className="btn-ghost-navy text-sm"
                                data-testid="urgency-cta-remplacement"
                            >
                                Remplacer un salarié absent
                            </Link>
                        </div>
                    </div>
                    <div className="md:col-span-4">
                        <div className="space-y-3">
                            <div className="sd-card p-4 flex items-center gap-3">
                                <div className="w-10 h-10 rounded-lg bg-red-100 text-red-700 flex items-center justify-center shrink-0">
                                    <Clock size={18} />
                                </div>
                                <div>
                                    <div className="font-display text-xl font-black text-red-700">&lt; 4 h</div>
                                    <div className="text-xs text-slate-500">candidature en semaine</div>
                                </div>
                            </div>
                            <div className="sd-card p-4 flex items-center gap-3">
                                <div className="w-10 h-10 rounded-lg bg-red-100 text-red-700 flex items-center justify-center shrink-0">
                                    <Zap size={18} />
                                </div>
                                <div>
                                    <div className="font-display text-xl font-black text-red-700">+10 %</div>
                                    <div className="text-xs text-slate-500">supplément urgence transparent</div>
                                </div>
                            </div>
                            <div className="sd-card p-4 flex items-center gap-3">
                                <div className="w-10 h-10 rounded-lg bg-red-100 text-red-700 flex items-center justify-center shrink-0">
                                    <MapPin size={18} />
                                </div>
                                <div>
                                    <div className="font-display text-xl font-black text-red-700">&lt; 20 min</div>
                                    <div className="text-xs text-slate-500">Super Talents géolocalisés</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
